<template>
    <div class="upload-area" @drop.prevent="addFile" @dragover.prevent @click="show_upload_box()">
        <icon file="upload" :size="32" />
        <span class="legend">
            Glisser un document ou
            <a>cliquer ici</a>
        </span>
        <form action class="upload" :class="{green: uploaded}">
            <input type="file" ref="upload_box" @change="handle_file_upload();" />
        </form>
        <div v-show="uploading" class="loading">
            <icon file="loader" :size="32" />
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import $ from "jquery";

export default {
	name: "el-upload",
	props: {
		parent_data: { default: null },
		property: { default: "" },
	},
	data () {
		return {
			uploading: false,
			uploaded: false,
			the_file: "",
		};
	},
	computed: {
		...mapGetters(["active_study", "active_project"])
	},
	methods: {
		addFile (e) {
			// console.log("add study file (drag/drop)");
			const droppedFiles = e.dataTransfer.files;
			if (!droppedFiles) return;
			this.study_file = droppedFiles[0];
			this.upload_file();
		},
		show_upload_box: function () {
			$(this.$refs.upload_box).click();
		},
		handle_file_upload: function () {
			// console.log("handle study pdf file upload (user clicked on upload zone)");
			const input = this.$refs.upload_box;
			if (input.files && input.files[0]) {
				this.study_file = input.files[0];
				this.upload_file();
			}
		},
		async upload_file () {
			this.uploading = true;
			this.uploaded = false;
			try {
				// console.log
				await this.$store.dispatch("upload_file_to_project", {
					the_file: this.study_file,
				});
				// console.log("uploaded, saving");
				this.$store.dispatch("save_study");
			} catch (error) {
				console.error("ERROR while uploading pdf study", error);
			}
			this.uploading = false;
			this.uploaded = true;
		}
	}
};
</script>

<style lang="stylus" scoped>
@import '../../../assets/css/app'

.upload-area
    display flex
    flex-direction column
    align-items center
    justify-content center
    margin 0 24px
    height 120px
    border 2px dashed #ddd
    background-color #f5f5f5
    border-radius radius
    color #bbb
    font-weight 500
    cursor pointer

    &:hover
        border-color #ccc
        background-color #eee

    .legend
        margin 4px 0 0 0

        a
            text-decoration underline

            &:hover
                text-decoration none

    input
        position absolute
        top 0
        left 10000px
        opacity 0

    .dropbox
        height @width
        border 2px dashed light
        border-radius radius
        background-color alpha(light, 5%)
        cursor pointer

        &:hover
            background-color alpha(light, 10%)

    &.green
        background-color green
        color white

        > .tooltip
            color white

        > .dropbox
            color white
            border none

        &:hover
            background-color darken(green, 15%)

.loading
    animation rotate 1s linear infinite
    color #bbb

@keyframes rotate
    from
        transform rotate(0deg)

    to
        transform rotate(359deg)
</style>